import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { img } from "../lib/format";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import WordReveal from "../components/WordReveal";

export default function Collections() {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    api.collections().then(setCollections).catch(() => {});
  }, []);

  return (
    <div className="pb-28" data-testid="collections-page">
      <SEO title="Collections — S H & SONS ®" description="Explore S H & SONS ® collections: lighting, home décor, tabletop, accessories, glass, metal, wood & metal, gifting." />
      <div className="pt-8 sm:pt-12 pb-6 text-center px-4">
        <WordReveal as="h1" text="Collections" className="h-display text-[clamp(2rem,9vw,3.75rem)] sm:text-7xl lg:text-[112px]" />
        <p className="mt-6 text-[13px] sm:text-[14px] text-charcoal/80 max-w-md mx-auto leading-relaxed">Eight edits across lighting, décor and the table — each built around a material story.</p>
      </div>
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8 mt-10 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {collections.map((c, i) => (
          <Reveal key={c.slug} delay={(i % 4) * 0.08}>
            <Link to={`/collections/${c.slug}`} className="group block text-center" data-testid={`collections-card-${c.slug}`}>
              <div className="overflow-hidden rounded-[22px] bg-beige aspect-[3/4]">
                <img src={img(c.image)} alt={`${c.name} collection`} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
              </div>
              <h2 className="mt-5 text-[18px] font-light group-hover:text-brass transition-colors duration-200">{c.name}</h2>
              <p className="mt-1 text-[11px] text-mocha">{c.product_count ?? 0} pieces</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
